import ca from './translations/ca';
import en from './translations/en';
import es from './translations/es';

export default { ca, en, es };
